export default {
    allow_to_make_payment_in_insurance_visits: "Sug'urta tashriflarida qo'shimcha to'lov qilishga ruxsat berish",
    insurance_companies: "Sug'urta kompaniyalari",
    insurance_polis: "Sug'urta polislari",
    limit: "Chegirma",
    number: "Raqam",
    paid_by_insurance: "Sug'urta tomonidan to'langan",
    paid_by_patient: "Bemor tomonidan to'langan",
    polis: "Sug'urta polisi",
    polises: "Siyosat",
    use_custom_prices_for_insurance: "Sug'urta kompaniyalari uchun maxsus narxlarni qo'llash",
    use_only_in_insurance: "Faqat sug'urta uchun foydalaning",
    valid_from: "Dan amal qiladi",
    valid_to: "Gacha amal qiladi",
    visit_should_have_polis_set_in_order_to_use_insurance_payment: "Tashrif sug'urta to'lovidan foydalanish uchun to'ldirilgan sug'urta polisiga ega bo'lishi kerak",
}
